import { forwardRef } from 'react';
import cn from 'bem-cn';

import { Stack } from '../UI';
import { getCurrentYear } from '../../utils/date/date';

import { FooterProps } from './Footer.types';
import './Footer.scss';
import { FOOTER_LINKS } from './Footer.constants';

const b = cn('footer');

export const Footer = forwardRef<HTMLDivElement, FooterProps>((props, ref) => {
    const { color, isLightColors } = props;

    const style = {
        '--main-color': color,
        '--is-light-colors': isLightColors ? 1 : 0,
    } as React.CSSProperties;

    const year = getCurrentYear();

    return (
        <Stack as="footer" ref={ref} className={b()} style={style}>
            <p>© {year} Яндекс</p>
            <Stack className={b('links')}>
                {FOOTER_LINKS.map((link, index) => (
                    <a key={`footer-link-${index}`} href={link.href} target="_blank" rel="noopener noreferrer">
                        {link.text}
                    </a>
                ))}
            </Stack>
        </Stack>
    );
});
